import Tracker from './Tracker';

const BundleTracker = new Tracker('Bundle', {
	ORDER_ROW_CHIP_CLICKED: 'orderRowChipClicked',
	ORDER_ROW_CHANGE_SAVED: 'orderRowChangeSaved'
});

export default BundleTracker;
